import logo from '../images/Logo.png'

function Logo(){
    return (
        <img src = {logo} alt = "logo"/>
    )
}

export default Logo;